import '../../Styles/UnitSelection.css';

import React from 'react';
import { Card } from 'antd';

import type { UnitType, CreateType } from './types';

interface UnitSelectionProps {
  onUnitSelect: (unitType: UnitType) => void;
  onCancel: () => void;
  createType: CreateType;
}

const UnitSelection: React.FC<UnitSelectionProps> = ({ onUnitSelect, onCancel, createType }) => {
  const handleBack = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('type');
    window.location.href = url.toString();
  };

  return (
    <div className='container py-4'>
      <div className='d-flex justify-content-between'>
        <a className='back-link' onClick={handleBack}>
          <svg
            aria-hidden='true'
            focusable='false'
            role='presentation'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='black'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M15 18l-6-6 6-6'
              stroke='black'
              strokeWidth='2'
              fill='none'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </a>

        <a className='cancel-link' onClick={onCancel}>
          <svg
            aria-hidden='true'
            focusable='false'
            role='presentation'
            width='24'
            height='24'
            viewBox='0 0 53 53'
            fill='black'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M41.9587 14.1554L38.8449 11.0416L26.5003 23.3862L14.1557 11.0416L11.042 14.1554L23.3866 26.5L11.042 38.8445L14.1557 41.9583L26.5003 29.6137L38.8449 41.9583L41.9587 38.8445L29.6141 26.5L41.9587 14.1554Z'
              stroke='none'
            />
          </svg>
        </a>
      </div>
      <h3 className='heading'>Select type of {createType}</h3>
      <div className='d-flex flex-direction-row cards-wrapper justify-content-center'>
        <div>
          <Card hoverable onClick={() => onUnitSelect('single')} className='card'>
            <img src='/single-unit.png' alt='single-unit' width={340} height={340} />
            <div className='card-bottom'>
              <h5>Single-Unit</h5>
              <p>For standalone properties or homes with one unit</p>
            </div>
          </Card>
        </div>
        <div>
          <Card hoverable onClick={() => onUnitSelect('multi')} className='card'>
            <img src='/multifamily.png' alt='Multifamily' width={340} height={340} />
            <div className='card-bottom'>
              <h5>Multi-Unit</h5>
              <p>For buildings with multiple units</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default UnitSelection;
